import { Popover } from 'antd';
import { useTheme } from 'styled-components';
import {
  useEffect, useMemo, useState,
} from 'react';
import _ from 'lodash';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { IconSvg } from 'shared/icon';
import { LocalStorageService } from 'services';
import { setCurrentBrandId } from 'app/userPreferences/slices';
import { selectCurrentBrandId } from 'app/userPreferences/selectors';
import { selectUserBrands } from 'app/auth/selectors';
import { Brand } from 'app/auth/types';
import { BrandSettings } from 'router/types';
import { Current } from 'app/userPreferences/types';
import {
  StyledHeaderSelectClose, StyledHeaderSelectToggle, StyledHeaderSelectWrapper, StyledListItemViewMode,
} from 'app/layout/components/Layout.styled';
import { AdminSelect } from 'shared/formControl';

interface BrandsProps {
  brandSettings: BrandSettings;
  brand: Brand;
}

const Brands = ({ brandSettings, brand }: BrandsProps) => {
  const [open, setOpen] = useState(false);
  const dispatch = useAppDispatch();
  const { colors } = useTheme();

  const brands = useAppSelector(selectUserBrands);
  const brandId = useAppSelector(selectCurrentBrandId);

  const isVisible = useMemo(() => brands?.length && (brandSettings?.editMode || brandSettings?.viewMode), [brandSettings?.editMode, brandSettings?.viewMode, brands?.length]);

  const brandsList = useMemo(() => {
    if (_.isNil(brandSettings?.isNewVersion)) {
      return brands;
    }
    return brands.filter((el) => el.isNewVersion === brandSettings?.isNewVersion);
  }, [brands, brandSettings?.isNewVersion]);

  useEffect(() => {
    if (brandsList?.length) {
      const currentData = LocalStorageService.get<Current>('current') || {};
      const id = currentData?.brandId || brandsList[0]?.id;
      if (id) {
        dispatch(setCurrentBrandId(id));

        LocalStorageService.set('current', {
          ...currentData,
          brandId: id,
        });
      }
    }
  }, [brandsList, dispatch]);

  if (!isVisible) {
    return;
  }

  if (brandSettings?.viewMode && brand?.name) {
    const { name } = brand;
    return (
      <Popover placement="bottomLeft" content={name} title="" rootClassName="description-popover">
        <StyledListItemViewMode $isBold>{name}</StyledListItemViewMode>
      </Popover>
    );
  }

  const openDropDown = () => {
    setOpen(true);
  };

  const closeDropDown = () => {
    setOpen(false);
  };

  const brandChange = (id: number) => {
    const currentData = LocalStorageService.get('current') || {};
    LocalStorageService.set('current', {
      ...currentData,
      brandId: id,
    });

    dispatch(setCurrentBrandId(id));
    closeDropDown();
  };

  return (
    !!brandsList.length && (
      <div>
        <StyledHeaderSelectToggle onClick={openDropDown}>
          <IconSvg icon="PartnersIcon" width="1.4rem" height="1.4rem" color={colors.white} />
        </StyledHeaderSelectToggle>
        <StyledHeaderSelectWrapper $isOpen={open}>
          <AdminSelect onChange={brandChange} value={brandId} allowClear={false} data={brandsList} isToString={false} virtual={false} />
          <StyledHeaderSelectClose onClick={closeDropDown}>
            <IconSvg icon="CloseModalIcon" width="1.14rem" height="1.14rem" color={colors.white} />
          </StyledHeaderSelectClose>
        </StyledHeaderSelectWrapper>
      </div>
    )
  );
};

export default Brands;
